var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkmedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.72 2.28a4.39 4.39 0 0 0-6.2 0L7.07 4.74a5.34 5.34 0 0 1 3.16.39l1.07-1.08a1.88 1.88 0 0 1 2.66 2.65l-1.08 1.08-.72.72-.86.86a1.87 1.87 0 0 1-2.43.18l-.22-.18a1.85 1.85 0 0 1-.18-.22.94.94 0 0 0-1.1.16l-1.08 1.1a4.35 4.35 0 0 0 5.66 1.54c.4-.2.79-.47 1.12-.81l.2-.2 2.46-2.46a4.39 4.39 0 0 0 0-6.19Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78 12.87 6.7 13.95a1.88 1.88 0 0 1-2.65-2.65l1.08-1.08.72-.72.85-.86a1.86 1.86 0 0 1 2.44-.18l.22.18.18.22c.35.18.8.13 1.1-.16l1.08-1.1A4.33 4.33 0 0 0 9.5 5.86a4.4 4.4 0 0 0-4.56 1.02l-.2.2-2.46 2.46a4.38 4.38 0 0 0 6.2 6.19l2.46-2.46c-1.06.2-2.16.06-3.16-.39Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkmedium);
export default __webpack_public_path__ + "static/media/link.medium.eb965551db7c0e12edf2f3b6b5e7181a.svg";
export { ForwardRef as ReactComponent };